export function toggleBlockShow() {
    const infoBlock = document.querySelector(".private-partnership-block");
    const parentBlock = document.querySelector(".toggle-block");
    $(".show-private-info").on("click", (e) => {
        e.preventDefault();
        parentBlock.classList.add("hidden");
        infoBlock.classList.contains("hidden") ? infoBlock.classList.remove("hidden") : false;
    });
    $(".private-partnership-block .back-btn").on("click", (e) => {
        e.preventDefault();
        parentBlock.classList.remove("hidden");
        !infoBlock.classList.contains("hidden") ? infoBlock.classList.add("hidden") : false;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/toggleBlockShow.js